// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"wa_a bhi_b","TwoDimsListFeature__item":"wa_b bhi_wb","TwoDimsListFeature__item__text":"wa_c bhi_vr"};